import Yup from 'utils/validation/yup-extensions';
import SchedulingDepartmentTable from '../../../../ApplicationRequest/components/containers/1616BridgesEpic/components/SchedulingDepartmentTable';

export const DepartmentSupplement = ({ formik }) => {
	return (
		<SchedulingDepartmentTable
			formik={formik}
			name={FORM_FIELD_KEYS.DEPARTMENTS}
			label={'Outpatient Scheduling Departments'}
			visible
			isRequired
		/>
	);
};

export const FORM_FIELD_KEYS = {
	DEPARTMENTS: 'DEPARTMENTS',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.DEPARTMENTS]: [
		{
			departmentId: null,
			departmentName: null,
			isPrimary: true,
		},
	],
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.DEPARTMENTS]: Yup.array()
		.of(
			Yup.object()
				.shape({
					departmentId: Yup.string().required().nullable(),
					departmentName: Yup.string()
						.required('Please search for and select a department.')
						.nullable(),
					isPrimary: Yup.bool(),
				})
				.nullable(),
		)
		.min(1, 'You must have at least one scheduling department.'),
};
